import { useEffect, useRef, useState } from 'react'
import { Markdown } from '~/components/ui/markdown'

/**
 * 타이핑 효과 — 비스트리밍 AI 텍스트를 한 글자씩 드러낸다(스트리밍 챗은 토큰 자체가 타이핑이라 불필요).
 * 길이에 비례해 한 틱에 여러 글자를 드러내, 아무리 길어도 ~3초 안에 끝낸다.
 */
export function Typewriter({
    text,
    markdown = true,
    className,
    onTick,
}: {
    text: string
    markdown?: boolean
    className?: string
    onTick?: () => void
}) {
    const [shown, setShown] = useState('')
    const onTickRef = useRef(onTick)
    onTickRef.current = onTick

    useEffect(() => {
        if (!text) {
            setShown('')
            return
        }
        let i = 0
        const step = Math.max(1, Math.ceil(text.length / 220))
        const timer = setInterval(() => {
            i = Math.min(text.length, i + step)
            setShown(text.slice(0, i))
            onTickRef.current?.()
            if (i >= text.length) clearInterval(timer)
        }, 16)
        return () => clearInterval(timer)
    }, [text])

    if (markdown) {
        return (
            <div className={className}>
                <Markdown>{shown}</Markdown>
            </div>
        )
    }
    return <span className={className}>{shown}</span>
}
